import { render } from "./move.vue?vue&type=template&id=78873cf1"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__